/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import InteractionEnum from 'astro/enum/interaction';

import * as Coords from 'shared/geo/coords';
import * as Shapes from 'shared/geo/shapes';


export default class
{
  constructor (cass)
  {
    this.cass = cass;
  }


  getKey ()
  {
    const { source, target } = this.cass;

    return target.parent.id + source.parent.id + target.id + source.id;
  }


  getCass ()
  {
    return this.cass;
  }


  getType ()
  {
    return this.cass;
  }


  getArgs ()
  {
    return this.cass.args;
  }


  getShape ()
  {
    return this.cass.shape;
  }


  getSource ()
  {
    return this.cass.source;
  }


  getTarget ()
  {
    return this.cass.target;
  }


  getUserID ()
  {
    return this.cass.user;
  }


  getUserReference ()
  {
    return this.cass.user;
  }


  isSourceOf (coords)
  {
    return this.cass.source.id.equals(coords);
  }


  isTargetOf (coords)
  {
    const { target, shape } = this.cass;

    return Coords.indexOf(Shapes.getCoords(target.id, shape), coords) !== -1;
  }


  isAggressive ()
  {
    const type = this.cass.type;

    return type === InteractionEnum.AttackEnergy;
  }


  isFutureTarget ()
  {
    const type = this.cass.type;

    return type === InteractionEnum.FutureTarget;
  }


  isProjectPlatform ()
  {
    const type = this.cass.type;

    return type === InteractionEnum.ProjectPlatform;
  }


};

